import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2, X } from 'lucide-react';
export function RecentPurchaseToast() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Show after 5 seconds
    const showTimer = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    // Hide after 10 seconds of showing
    const hideTimer = setTimeout(() => {
      setIsVisible(false);
    }, 15000);
    return () => {
      clearTimeout(showTimer);
      clearTimeout(hideTimer);
    };
  }, []);
  return <AnimatePresence data-id="element-10">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-4 left-4 z-50 bg-emerald-950 rounded-xl shadow-2xl shadow-black/50 border border-emerald-700/50 p-4 max-w-sm flex items-start gap-3" data-id="element-11">
          <div className="bg-emerald-500/15 border border-emerald-500/30 p-2 rounded-full shrink-0" data-id="element-12">
            <CheckCircle2 className="w-5 h-5 text-emerald-400" data-id="element-13" />
          </div>
          <div className="flex-1" data-id="element-14">
            <div className="flex justify-between items-start" data-id="element-15">
              <p className="text-xs font-bold text-emerald-400/70 uppercase tracking-wider mb-1" data-id="element-16">
                Compra verificada
              </p>
              <button onClick={() => setIsVisible(false)} className="text-emerald-500/50 hover:text-emerald-300" data-id="element-17">
                <X className="w-4 h-4" data-id="element-18" />
              </button>
            </div>
            <p className="text-sm text-emerald-50 font-medium leading-tight" data-id="element-19">
              <span className="font-bold" data-id="element-20">Romina A.</span> de Tucumán compró{' '}
              <span className="font-bold text-emerald-300" data-id="element-21">
                Kit Reclamo Médico Urgente 🏥
              </span>
            </p>
            <p className="text-xs text-emerald-400/60 mt-1" data-id="element-22">hace 5 minutos</p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}